"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const marketplace_1 = __importDefault(require("./integrations/marketplace"));
const utils_1 = require("./utils");
class JellyCollection {
    constructor(collection, marketplaceService, wicpService, collectionService, hubService) {
        this.getAllNFTs = (params) => __awaiter(this, void 0, void 0, function* () {
            return this.marketplaceService.getAllNFTs(params);
        });
        this.getNFTs = (params) => __awaiter(this, void 0, void 0, function* () {
            return this.marketplaceService.getNFTs(params);
        });
        this.getAssetsToWithdraw = (params) => __awaiter(this, void 0, void 0, function* () {
            return this.marketplaceService.getAssetsToWithdraw(params);
        });
        this.getCollection = (params) => __awaiter(this, void 0, void 0, function* () {
            return this.marketplaceService.getCollection(params);
        });
        this.requestApproval = (params) => __awaiter(this, void 0, void 0, function* () {
            return this.wicpService.requestApproval(params);
        });
        this.makeOffer = (params) => __awaiter(this, void 0, void 0, function* () {
            return this.marketplaceService.makeOffer(params);
        });
        this.requestTokenApproval = (params) => __awaiter(this, void 0, void 0, function* () {
            return this.collectionService.requestTokenApproval(params);
        });
        this.acceptOffer = (params) => __awaiter(this, void 0, void 0, function* () {
            return this.marketplaceService.acceptOffer(params);
        });
        this.cancelOffer = (params) => __awaiter(this, void 0, void 0, function* () {
            return this.marketplaceService.cancelOffer(params);
        });
        this.rejectOffer = (params) => __awaiter(this, void 0, void 0, function* () {
            return this.marketplaceService.rejectOffer(params);
        });
        this.getProtocolFee = () => __awaiter(this, void 0, void 0, function* () {
            return this.marketplaceService.getProtocolFee();
        });
        this.addToListing = (params) => __awaiter(this, void 0, void 0, function* () {
            return this.hubService.addToListing(params, this.collection);
        });
        this.removeFromListing = (params) => __awaiter(this, void 0, void 0, function* () {
            return this.hubService.removeFromListing(params, this.collection);
        });
        this.buy = (params) => __awaiter(this, void 0, void 0, function* () {
            return this.hubService.buy(params, this.collection);
        });
        this.getTraits = () => __awaiter(this, void 0, void 0, function* () {
            return this.marketplaceService.getTraits();
        });
        this.withdrawFungible = (params = {
            fungibleId: this.collection.fungibleId,
            fungibleStandard: Object.keys(this.collection.fungibleStandard)[0]
        }) => __awaiter(this, void 0, void 0, function* () {
            return this.marketplaceService.withdrawFungible(params);
        });
        this.getUserNFTIds = (params) => {
            return this.collectionService.getTokenIds(params);
        };
        this.getUserNFTs = (params) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const myTokenIdsResponse = yield this.getUserNFTIds(params);
            const emptyResponse = { ok: true, data: [] };
            if (!myTokenIdsResponse.ok) {
                if (((_a = myTokenIdsResponse.error) === null || _a === void 0 ? void 0 : _a.type) === 'OwnerNotFound') {
                    return emptyResponse;
                }
                return myTokenIdsResponse;
            }
            if (!myTokenIdsResponse.data || !myTokenIdsResponse.data.length) {
                return emptyResponse;
            }
            const nftsResponse = yield this.getNFTs({ ids: myTokenIdsResponse.data });
            if (!nftsResponse.ok || !params.withOffers) {
                return nftsResponse;
            }
            const offeredNfts = (_b = nftsResponse.data) === null || _b === void 0 ? void 0 : _b.filter((nft) => nft.offers.length > 0);
            return Object.assign(Object.assign({}, nftsResponse), { data: offeredNfts });
        });
        this.getFloorPrice = () => __awaiter(this, void 0, void 0, function* () {
            return this.marketplaceService.getFloorPrice();
        });
        this.getUniqueNFTOwners = () => __awaiter(this, void 0, void 0, function* () {
            return this.collectionService.getUniqueNFTOwners();
        });
        this.collection = collection;
        this.marketplaceService = marketplaceService;
        this.wicpService = wicpService;
        this.collectionService = collectionService;
        this.hubService = hubService;
    }
    getPlugTransaction(transaction, onSuccess = (res) => Promise.resolve(res), onFailure = () => Promise.resolve()) {
        // Some castings as any are necessary because of TS limitations in overload functions
        // with Union types explained in this link: https://github.com/microsoft/TypeScript/issues/44452
        // The main focus is in the external interface working correctly, which it does.
        switch (transaction.method) {
            case utils_1.TransactionName.makeOffer:
            case utils_1.TransactionName.acceptOffer:
            case utils_1.TransactionName.cancelOffer: {
                return this.marketplaceService.getPlugTransaction(transaction, onSuccess, onFailure);
            }
            case utils_1.TransactionName.requestTokenApproval: {
                return this.collectionService.getPlugTransaction(transaction, onSuccess, onFailure);
            }
            case utils_1.TransactionName.addToListing:
            case utils_1.TransactionName.removeFromListing:
            case utils_1.TransactionName.buy: {
                return this.hubService.getPlugTransaction(this.collection, transaction, onSuccess, onFailure);
            }
            case utils_1.TransactionName.requestApproval: {
                return this.wicpService.getPlugTransaction(transaction, onSuccess, onFailure);
            }
            default: {
                throw new Error('Unsupported method');
            }
        }
    }
}
exports.default = JellyCollection;
